import React from 'react';
import Card from '../../shared/Card';
import ReportForm from './ReportForm';

const ReportGenerator = ({ onReportGenerated, onJobSubmitted }) => {
  return (
    <div className="report-generator">
      <Card title="Generate Analysis Report" className="generator-card">
        <ReportForm onReportGenerated={onReportGenerated} onJobSubmitted={onJobSubmitted} />
      </Card>
    </div>
  );
};

export default ReportGenerator;